export default __webpack_public_path__ + "c2a12afbb984cfa0b7b7b727041af265.png";